import { GQLShiftConflictsFragmentFragment } from 'codegen/gql-types';
import { Component, Prop } from 'vue-property-decorator';
import { Component as TsxComponent } from 'vue-tsx-support';

import styles from './conflicts.css';

@Component
export default class RestrictedShiftPresetsConflict extends TsxComponent<{
  conflict: Extract<
    GQLShiftConflictsFragmentFragment,
    { __typename: 'RestrictedShiftPresetsConflict' }
  >;
  isSelf?: boolean;
}> {
  @Prop()
  public conflict: Extract<
    GQLShiftConflictsFragmentFragment,
    { __typename: 'RestrictedShiftPresetsConflict' }
  >;

  @Prop()
  public isSelf?: boolean;

  protected get translationKey() {
    return this.isSelf
      ? 'conflicts.restrictedShiftPresets.textSelf'
      : 'conflicts.restrictedShiftPresets.textStakeholder';
  }

  public render() {
    return (
      <section>
        <h3 class={styles.conflictsItemTitle}>
          {this.$t('conflicts.restrictedShiftPresets.title')}
        </h3>
        <p class={styles.conflictsItemText}>
          {this.$t(this.translationKey, {
            presets: this.conflict.restrictedShiftPresets.join(', '),
          })}
        </p>
      </section>
    );
  }
}
